module.exports = __webpack_public_path__ + "static/media/Rattata_gaussian2.5faa4c5b.png";